import { PatientRoute } from "./PatientRoute";
import { useHistory } from "react-router";
import { useCallback } from "react";
import { getCurrentEnumRoute } from "fe-common/routes/commonPathUtils";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";

export function routeWithQueryParam(history, route) {
  history.push({
    pathname: route,
    search: history?.location.search,
  });
}

export function usePatientRouteChanger() {
  const history = useHistory();

  const removeLastPatientRoute = (path: string = "") => {
    const currentRoute = getCurrentEnumRoute(path, PatientRoute);
    const slicedIndex = path?.indexOf(currentRoute);
    return removeTrailingSlash(
      slicedIndex > -1 ? path?.slice(0, slicedIndex) : path,
    );
  };

  return useCallback(
    //accept only known routes which are part of the PatientFacingRouter
    (route: PatientRoute | string, params: object = null) => {
      const matchPath = removeLastPatientRoute(history?.location?.pathname);
      // console.log(
      //   `Routing to ${matchPath}/${route}`,
      //   route,
      //   history.location,
      //   match.path,
      // );
      const searchParams = new URLSearchParams(history?.location?.search);
      if (params && params === Object(params)) {
        Object.keys(params).forEach((k) =>
          params[k] ? searchParams.set(k, params[k]) : "",
        );
      }
      history.push({
        // use relative routing, so that
        // we dont destructively affect the path above the root of the PatientFacingRouter.
        pathname: `${matchPath}/${route}`,
        search: searchParams.toString(),
      });
    },
    [history],
  );
}
